import { render } from "./EventsView.vue?vue&type=template&id=be53eae2&scoped=true"
import script from "./EventsView.vue?vue&type=script&lang=js"
export * from "./EventsView.vue?vue&type=script&lang=js"

import "./EventsView.vue?vue&type=style&index=0&id=be53eae2&scoped=true&lang=css"

import exportComponent from "D:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be53eae2"]])

export default __exports__